export default "__VITE_ASSET__BOfZ3JZ0__"